import { Pipe, PipeTransform } from '@angular/core';
import { PrintCardColumnViewModel } from '../../../../../../../display/components/menus/product-menu/building-blocks/menu-section/product-section/section-column-view-models/print-card-column-view-model';

@Pipe({
  name: 'fikaSpoofedGridColViewModels',
  standalone: false
})
export class FikaSpoofedGridColViewModelsPipe implements PipeTransform {
  transform(printCardColumnViewModels: PrintCardColumnViewModel[], take: number): PrintCardColumnViewModel[] {
    return Number.isFinite(take) ? printCardColumnViewModels?.take(take) : printCardColumnViewModels;
  }
}
